import React from 'react';

import { SpecCourseLessonViewRulesBlockWrapper } from 'common.components/spec-course-lesson-view/__rules-block-wrapper/spec-course-lesson-view__rules-block-wrapper';
import { SpecCourseLessonViewRulesContainer } from 'common.components/spec-course-lesson-view/__rules/spec-course-lesson-view__rules.container';

export const SpecCourseLessonViewRulesTabContent = () => {
    return (
        <>
            <SpecCourseLessonViewRulesContainer specialRules={<SpecCourseLessonViewRulesBlockWrapper />} />
        </>
    );
};
